import React from 'react';
import { CtaButton } from './CtaButton';
export function UrgencySection() {
  return <section className="navy-texture w-full py-20 sm:py-28" data-id="element-101" data-mp="2sit1phcgikic">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-102" data-mp="2sgg9mbczitrk">
        <span className="section-label" data-id="element-103" data-mp="36azh317scngq">Cupo limitado</span>
        <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-white sm:text-6xl" data-id="element-104" data-mp="31j91ogtzr9ig">
          Solo 50 Cupos Disponibles
        </h2>
        <div className="mx-auto mt-7 h-px w-16 bg-gold" aria-hidden="true" data-id="element-105" data-mp="3g6u4e9myf6pu" />
        <p className="mx-auto mt-8 max-w-xl font-sans text-base font-light leading-relaxed text-white/85 sm:text-lg" data-id="element-106" data-mp="3b9k9iegsq2um">
          Este seminario es completamente gratuito y los lugares se están llenando. Reserva el tuyo
          hoy antes de que se agoten.
        </p>
        <div className="mt-10" data-id="element-107" data-mp="3l5dtuk0rb0my">
          <CtaButton size="lg" className="w-full sm:w-auto" data-id="element-108" data-mp="1uu0sjaogzy4j">
            Quiero mi lugar gratis
          </CtaButton>
        </div>
      </div>
    </section>;
}